import type { RouteLocationNormalized } from 'vue-router';
import { getController } from '@/api/controllers';
import { i18n } from '@/i18n';
import { displayError } from '@/utils/displayError';

/**
 * Verifies that the controller belongs to the organization specified in the URL.
 * If not, it redirects to the correct organization.
 */
export const checkControllerOrganization = async (
  to: RouteLocationNormalized,
) => {
  try {
    const controller = await getController(String(to.params.serialNumber));

    if (
      controller.organization.id !== String(to.params.organizationId)
    ) {
      return {
        name: 'controller',
        params: {
          ...to.params,
          organizationId: controller.organization.id,
        },
      };
    }
    return true;
  } catch (error: any) {
    if (error?.response?.status === 404) {
      displayError([i18n.global.t('controllerNotFound')]);
    } else {
      displayError([i18n.global.t('controllerLoadError')]);
    }
    return { name: 'organizations' };
  }
};
